@import '../../styles/palette.scss';

.list {
  padding-inline-start: 2em;

  &.ordered {
    list-style: decimal;
  }

  &.unordered {
    list-style: disc;
  }
}
